import { History } from "lucide-react";
import { useLang } from "@/i18n";

const ENTRIES = [
  {
    date: "2026-02-12",
    title_tr: "API ürün açıklamaları güncellendi",
    title_en: "Paid API product descriptions updated",
    body_tr:
      "Ücretli içerik üretim API'sinin çalışma modeli, içerik türleri ve halka açık editoryal portal ile arasındaki hizmet ayrımı kullanıcıların daha açık anlayabileceği şekilde güncellendi. Mevcut hesaplar, API anahtarları, planlar, endpointler ve müşteri bakiyeleri korunmuştur.",
    body_en:
      "Paid API product descriptions were updated to more clearly explain the content-generation workflow, supported content types and separation from the public editorial portal. Existing accounts, API keys, plans, endpoints and customer balances were preserved.",
  },
];

export default function Changelog() {
  const { lang } = useLang();
  const t = (tr, en) => (lang === "tr" ? tr : en);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="changelog-page">
      <div className="flex items-center gap-3 mb-6">
        <History className="text-red-500" size={28} />
        <span className="eyebrow text-red-500">DEĞİŞİKLİKLER · Loft Press</span>
      </div>
      <h1 className="headline text-5xl sm:text-6xl text-white">
        {t("Değişiklik Günlüğü", "Changelog")}
      </h1>

      <div className="mt-12 space-y-8">
        {ENTRIES.map((e) => (
          <article key={e.date + e.title_en} className="bg-neutral-950 border border-neutral-800 rounded-sm p-6" data-testid={`changelog-${e.date}`}>
            <p className="text-xs font-mono uppercase tracking-wider text-neutral-500">{e.date}</p>
            <h2 className="headline text-2xl text-white mt-2">{lang === "tr" ? e.title_tr : e.title_en}</h2>
            <p className="mt-3 text-base text-neutral-300 leading-relaxed">{lang === "tr" ? e.body_tr : e.body_en}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
